export default theme => ({
  root: {
    position: 'fixed',
    right: '24px',
    bottom: '24px',

    width: 'fit-content',
    maxWidth: 'calc(100vw - 48px)',
    minHeight: '56px',

    boxSizing: 'border-box',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',

    gap: '12px',
    padding: '10px 12px',

    borderRadius: '12px',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',

    fontFamily: theme.typography.fontFamily,

    zIndex: theme.zIndex.snackbar,
  },

  processing: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E4E7EC',
    color: '#344054',
  },

  error: {
    backgroundColor: '#FFF3F2',
    border: '1px solid #FECDCA',
    color: '#B42318',
  },

  finished: {
    backgroundColor: '#ECFDF3',
    border: '1px solid #ABEFC6',
    color: '#067647',
  },

  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexShrink: 0,
  },

  label: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',

    whiteSpace: 'nowrap',
  },

  actionButton: {
    flexShrink: 0,
    whiteSpace: 'nowrap',

    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    boxShadow: 'none',
  },

  retryButton: {
    backgroundColor: '#FEE4E2',
    color: '#B42318',

    '&:hover': {
      backgroundColor: '#FECDCA',
    },
  },

  downloadButton: {
    backgroundColor: '#039855',
    color: '#FFFFFF',

    '&:hover': {
      backgroundColor: '#027A48',
    },
  },
})
